import Icon from "../Icon";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import React from "react";

export interface SocialIconProps {
  href: string;
  color: string;
  icon: IconProp;
}

const SocialIcon = ({ href, color, icon }: SocialIconProps) => {
  return (
    <a
      className="flex items-center justify-center mr-2 text-xs text-white rounded-full hover:text-white"
      href={href}
      style={{
        backgroundColor: color,
        width: "25px",
        height: "25px",
      }}
    >
      <Icon icon={icon} />
    </a>
  );
};

export default SocialIcon;
